import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function AddBarrio({ handleNewBarrio, editBarrio }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [pais, setPais] = useState('');
    const [depto, setDepto] = useState('');
    const [municipio, setMunicipio] = useState('');
    const [barrio, setBarrio] = useState('');
    const [deptos, setDeptos] = useState([]);
    const [paises, setPaises] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    // Obtener la fecha sin el caracter 'Z'
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        return fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
    }

    const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        if (editBarrio) {
            setBarrio(editBarrio.nombreBarrioColonia);
            setMunicipio(editBarrio.idMunicipio);
            setDepto(editBarrio.deptoId);
            setPais(editBarrio.paisId);
            setIngresadoPor(editBarrio.ingresadoPor);

            setModificacion(2);
        } else {
            resetForm();
            setModificacion(1);
            setIngresadoPor('');

        }
    }, [editBarrio]);

    useEffect(() => {
        fetchPaises();
    }, []);

    useEffect(() => {
        if (pais) fetchDepartamentos(pais);
    }, [pais]);

    useEffect(() => {
        if (depto) fetchMunicipios(depto);
    }, [depto]);

    const resetForm = () => {
        setBarrio('');
        setMunicipio('');
        setDepto('');
        setPais('');
    };

    const fetchPaises = async () => {
        try {
            const response = await fetch(`${server}/MgPaises`);
            const data = await response.json();
            setPaises(data.$values);
        } catch (error) {
            console.error('Error al cargar los paises:', error);
        }
    };

    const fetchDepartamentos = async (paisId) => {
        try {
            const response = await fetch(`${server}/MgDepartamentoes/departamentosbypais/${paisId}`);
            const data = await response.json();
            setDeptos(data.$values);
        } catch (error) {
            console.error('Error al cargar los departamentos:', error);
            setDeptos([]);
        }
    };

    const fetchMunicipios = async (deptoId) => {
        try {
            const response = await fetch(`${server}/MgMunicipios/municipiosbydepartamento/${deptoId}`);
            const data = await response.json();
            setMunicipios(data.$values);
        } catch (error) {
            console.error('Error al cargar los municipios:', error);
            setMunicipios([]);
        }
    };
    

    const handleSubmit = async (e) => {
        e.preventDefault();
        

        const method = editBarrio ? 'PUT' : 'POST';
        const endpoint = editBarrio ? `${server}/MgBarriosColonias/${editBarrio.idBarrioColonia}` : `${server}/MgBarriosColonias`;

        const nuevoBarrio = {
            idBarrioColonia:editBarrio ? editBarrio.idBarrioColonia : 0,
            idMunicipio:municipio,
            nombreBarrioColonia:barrio,
            IngresadoPor: !editBarrio ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editBarrio ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
          
        };
        Object.keys(nuevoBarrio).forEach(key => nuevoBarrio[key] === undefined && delete nuevoBarrio[key]);

        try {
            const response = await fetch(endpoint, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(nuevoBarrio),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
                resetForm();
                handleNewBarrio();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });            }
        } catch (error) {

            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el barrio',
                text: error || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>{editBarrio ? 'Editar Barrio' : 'Agregar Nuevo Barrio'}</h2>
            <br />
            <form onSubmit={handleSubmit} className="form-horizontal form-label-left">
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="pais">País</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={pais} onChange={(e) => setPais(e.target.value)}>
                            <option value="">Elija una opción</option>
                            {paises.map((pais) => (
                                <option key={pais.idPais} value={pais.idPais}>{pais.nombrePais}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="depto">Departamento</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={depto} onChange={(e) => setDepto(e.target.value)}>
                            <option value="">Elija una opción</option>
                            {deptos.map((depto) => (
                                <option key={depto.idDepartamento} value={depto.idDepartamento}>{depto.nombreDepartamento}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="item form-group">
                    <label className="control-label col-md-3 col-sm-3 label-align" htmlFor="municipio">Municipio</label>
                    <div className="col-md-3 col-sm-6">
                        <select className="form-control" value={municipio} onChange={(e) => setMunicipio(e.target.value)}>
                            <option value="">Elija una opción</option>
                            {municipios.map((municipio) => (
                                <option key={municipio.idMunicipio} value={municipio.idMunicipio}>{municipio.nombreMunicipio}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="barrio">Barrio o Colonia:</label>
                    <div className="col-md-2 col-sm-3">
                        <input
                            type="text"
                            id="barrio"
                            required="required"
                            className="form-control"
                            value={barrio}
                            onChange={(e) => setBarrio(e.target.value)}
                        />
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Barrio')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddBarrio;
